import { apiGet, apiPut } from './api';
import {
  Reward,
  ActivityEntry,
  Statement,
  TaxDocument,
  LoginHistoryEntry,
  UserSettings,
} from '../types/user';
import { AccountSummary } from '../types/portfolio';
import { Transfer } from '../types/payment';

export async function fetchProfileBalances(): Promise<AccountSummary> {
  return apiGet<AccountSummary>('/profile/balances');
}

export async function fetchProfileTransfers(): Promise<Transfer[]> {
  return apiGet<Transfer[]>('/profile/transfers');
}

export async function fetchRewards(): Promise<Reward[]> {
  return apiGet<Reward[]>('/profile/rewards');
}

export async function fetchHistory(): Promise<ActivityEntry[]> {
  return apiGet<ActivityEntry[]>('/profile/history');
}

export async function fetchStatements(): Promise<Statement[]> {
  return apiGet<Statement[]>('/profile/statements');
}

export async function fetchTaxDocuments(): Promise<TaxDocument[]> {
  return apiGet<TaxDocument[]>('/profile/tax');
}

export async function fetchLoginHistory(): Promise<LoginHistoryEntry[]> {
  return apiGet<LoginHistoryEntry[]>('/profile/security');
}

export async function updateUserSettings(
  userId: string,
  settings: Partial<UserSettings>,
): Promise<void> {
  return apiPut<void>(`/users/${userId}`, settings);
}
